import { apolloClient } from '@/vue-apollo'
import AddEnterpriseCustomer from '@/graphql/mutations/AddEnterpriseCustomer'
import AddEnterpriseMember from '@/graphql/mutations/AddEnterpriseMember'
import RemoveEnterpriseMember from '@/graphql/mutations/RemoveEnterpriseMember'
import ListEnterpriseCustomers from '@/graphql/queries/ListEnterpriseCustomers'
import UpdateEnterpriseCustomer from '@/graphql/mutations/UpdateEnterpriseCustomer'

export const enterpriseCustomers = {
  namespaced: true,
  state: {
    enterpriseCustomers: [],
    loadingEnterpriseCustomers: false,
    loadingAddEnterpriseCustomer: false,
    loadingUpdateEnterpriseCustomer: false,
    loadingAddEnterpriseMember: false,
    loadingRemoveEnterpriseMember: false

  },
  mutations: {
    setEnterpriseCustomers (state, enterpriseCustomers) {
      state.enterpriseCustomers = enterpriseCustomers
    },
    setLoadingEnterpriseCustomers (state, loadingEnterpriseCustomers) {
      state.loadingEnterpriseCustomers = loadingEnterpriseCustomers
    },
    setLoadingAddEnterpriseCustomer (state, loadingAddEnterpriseCustomer) {
      state.loadingAddEnterpriseCustomer = loadingAddEnterpriseCustomer
    },
    setLoadingUpdateEnterpriseCustomer (state, loadingUpdateEnterpriseCustomer) {
      state.loadingUpdateEnterpriseCustomer = loadingUpdateEnterpriseCustomer
    },
    setLoadingAddEnterpriseMember (state, loadingAddEnterpriseMember) {
      state.loadingAddEnterpriseMember = loadingAddEnterpriseMember
    },
    setLoadingRemoveEnterpriseMember (state, loadingRemoveEnterpriseMember) {
      state.loadingRemoveEnterpriseMember = loadingRemoveEnterpriseMember
    }
  },
  actions: {
    async listEnterpriseCustomers ({ commit, state, rootGetters, dispatch }) {
      try {
        commit('setLoadingEnterpriseCustomers', true)
        const res = await apolloClient.query({
          query: ListEnterpriseCustomers,
          fetchPolicy: 'no-cache'
        })
        commit('setEnterpriseCustomers', res.data.listEnterpriseCustomers)
        commit('setLoadingEnterpriseCustomers', false)
        return res.data.listEnterpriseCustomers
      } catch (e) {
        console.log(e)
        commit('setLoadingEnterpriseCustomers', false)
        commit('snackbar/showMessage', {
          content: 'Error, try again!',
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async addEnterpriseCustomer ({ commit, state, rootGetters, dispatch }, {
      company,
      startDate,
      expirationDate,
      quantity,
      payerUserId
    }) {
      try {
        commit('setLoadingAddEnterpriseCustomer', true)
        const res = await apolloClient.mutate({
          mutation: AddEnterpriseCustomer,
          variables: {
            company,
            startDate,
            expirationDate,
            quantity,
            payerUserId
          },
          fetchPolicy: 'no-cache'
        })
        commit('setLoadingAddEnterpriseCustomer', false)
        return res.data.addEnterpriseCustomer
      } catch (e) {
        console.log(e)
        commit('setLoadingAddEnterpriseCustomer', false)
        commit('snackbar/showMessage', {
          content: 'Error, try again!',
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async updateEnterpriseCustomer ({ commit, state, rootGetters, dispatch }, {
      enterpriseUserId,
      input
    }) {
      try {
        commit('setLoadingUpdateEnterpriseCustomer', true)
        const res = await apolloClient.mutate({
          mutation: UpdateEnterpriseCustomer,
          variables: { enterpriseUserId, input },
          fetchPolicy: 'no-cache'
        })
        const result = res.data.updateEnterpriseCustomer

        const updatedEnterpriseCustomers = state.enterpriseCustomers.map(customer => {
          if (customer.id === result.id) {
            return { ...customer, ...result }
          }
          return customer
        })
        commit('setEnterpriseCustomers', updatedEnterpriseCustomers)
        commit('setLoadingUpdateEnterpriseCustomer', false)
        return res.data.updateEnterpriseCustomer
      } catch (e) {
        console.log(e)
        commit('setLoadingUpdateEnterpriseCustomer', false)
        commit('snackbar/showMessage', {
          content: 'Error, try again!',
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async addEnterpriseMember ({ commit, state, rootGetters, dispatch }, {
      email,
      payerUserId
    }) {
      try {
        commit('setLoadingAddEnterpriseMember', true)
        const res = await apolloClient.mutate({
          mutation: AddEnterpriseMember,
          variables: {
            email,
            payerUserId
          },
          fetchPolicy: 'no-cache'
        })
        const result = res.data.addEnterpriseMember
        commit('setLoadingAddEnterpriseMember', false)
        return result
      } catch (e) {
        console.dir(e)
        commit('setLoadingAddEnterpriseMember', false)
        commit('snackbar/showMessage', {
          content: e.message,
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    },
    async removeEnterpriseMember ({ commit, state, rootGetters, dispatch }, { email }) {
      try {
        commit('setLoadingRemoveEnterpriseMember', true)
        const res = await apolloClient.mutate({
          mutation: RemoveEnterpriseMember,
          variables: { email },
          fetchPolicy: 'no-cache'
        })
        const result = res.data.removeEnterpriseMember
        commit('setLoadingRemoveEnterpriseMember', false)
        return result
      } catch (e) {
        console.dir(e)
        commit('setLoadingRemoveEnterpriseMember', false)
        commit('snackbar/showMessage', {
          content: e.message,
          timeout: 6000,
          color: 'red',
          location: 'center center'
        }, { root: true })
      }
    }
  }
}
